import React from 'react'
import { LogoItem } from './LogoStyles'
import LogoImg from '../../images/rps.png';

const Logo = () => {
  return (
    <LogoItem src={LogoImg} alt="Logo"/>
  )
}

export default Logo